import { Action } from '@ngrx/store';
import * as models from '../../domain/models';

export const LOAD = '[RM Faa Import Execution] Load';
export const LOAD_SUCCESS = '[RM Faa Import Execution] Load Success';
export const LOAD_FAIL = '[RM Faa Import Execution] Load Fail';
export const RESET = '[RM Faa Import Execution] Reset';

export class LoadAction implements Action {
  readonly type = LOAD;
}

export class LoadSuccessPayload {
  constructor(public item: models.FaaImportExecution) {}
}

export class LoadSuccessAction implements Action {
  readonly type = LOAD_SUCCESS;

  constructor(public payload: LoadSuccessPayload) {}
}

export class LoadFailAction implements Action {
  readonly type = LOAD_FAIL;
}

export class ResetAction implements Action {
  readonly type = RESET;
}

export type Actions = LoadAction | LoadSuccessAction | LoadFailAction | ResetAction;
